import React from 'react';
import { getMergeSortAnimations } from '../sortingAlgorithms/sortingAlgorithms.js';
import './SortingVisualizer.css';

// Change this value for the speed of the animations.
const ANIMATION_SPEED_MS = 10;

// Change this value for the number of bars (value) in the array.
const NUMBER_OF_ARRAY_BARS = 40;

// Change this value for the max height of array bars
const MAX_HEIGHT_OF_ARRAY_BARS = 300;

// This is the main color of the array bars.
const PRIMARY_COLOR = '#516da1';

// This is the color of array bars that are being compared throughout the animations.
const SECONDARY_COLOR = '#2e970e';

export default class SortingVisualizer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortingArray: [],
    };
  }

  componentDidMount() {
    this.resetArray();
  }

  resetArray() {
    const sortingArray = [];
    for (let i = 0; i < NUMBER_OF_ARRAY_BARS; i++) {
      sortingArray.push(randomIntFromInterval(5, MAX_HEIGHT_OF_ARRAY_BARS));
    }
    this.setState({ sortingArray });
  }

  mergeSort() {
    const animations = getMergeSortAnimations(this.state.sortingArray);
    for (let i = 0; i < animations.length; i++) {
      const arrayBars = document.getElementsByClassName('array-bar');
      const isColorChange = i % 3 !== 2;
      if (isColorChange) {
        const [barOneIdx, barTwoIdx] = animations[i];
        const barOne = arrayBars[barOneIdx];
        const barTwo = arrayBars[barTwoIdx];
        const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;
        setTimeout(() => {
          barOne.setAttribute('fill', color);
          barTwo.setAttribute('fill', color);
        }, i * ANIMATION_SPEED_MS);
      } else {
        setTimeout(() => {
          const [barOneIdx, newHeight] = animations[i];
          const barOne = arrayBars[barOneIdx];
          barOne.setAttribute('height', newHeight);
          barOne.setAttribute('y', MAX_HEIGHT_OF_ARRAY_BARS / 2 - newHeight / 2);
        }, i * ANIMATION_SPEED_MS);
      }
    }
  }

  render() {
    const { sortingArray } = this.state;

    return (
      <div className="array-container">

        <svg width="600" height={MAX_HEIGHT_OF_ARRAY_BARS} xmlns="http://www.w3.org/2000/svg">
          <g>
            {sortingArray.map((value, idx) => (
              <rect
                className='array-bar'
                id={idx}
                key={idx}
                height={value}
                width='10'
                y={MAX_HEIGHT_OF_ARRAY_BARS / 2 - value / 2}
                x={idx * 15}
                rx='1'
                ry='1'
                strokeWidth="1"
                stroke="#000"
                fill={PRIMARY_COLOR}
              />
            ))
            }
          </g>
        </svg>
        <br></br>
        <div>
          <center>
            <button className="button" onClick={() => this.resetArray()}>New Array</button>
            <button className="button" onClick={() => this.mergeSort()}>Sort</button>
          </center>
        </div>
      </div >
    );

  }
}

// From https://stackoverflow.com/questions/4959975/generate-random-number-between-two-numbers-in-javascript
function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

// // Function to check if arrays are equal
// function arraysAreEqual(arrayOne, arrayTwo) {
//   if (arrayOne.length !== arrayTwo.length) return false;
//   for (let i = 0; i < arrayOne.length; i++) {
//     if (arrayOne[i] !== arrayTwo[i]) {
//       return false;
//     }
//   }
//   return true;
// }